<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Leave Type"
      text="Edit Leave Type"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <span class="font-weight-bold">Leave Type: {{ localLeaveType.name }}</span>
            </v-col>
          </v-row>

          <v-row class="font-weight-black">
            <v-col
              cols="3"
              class="py-0"
            >
              <span> Is Paid Leave? </span>
              <v-radio-group
                v-model="localLeaveType.is_paid_leave"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="3"
              class="py-0"
            >
              <span> Is Prorated? </span>
              <v-radio-group
                v-model="localLeaveType.is_prorated"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="3"
              class="py-0"
            >
              <span> Is Carry Forwardable? </span>
              <v-radio-group
                v-model="localLeaveType.is_carry_forwardable"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row class="font-weight-black">
            <v-col
              cols="3"
              class="py-0"
            >
              <span> Auto Select End Date? </span>
              <v-radio-group
                v-model="localLeaveType.is_continuous"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="3"
              class="py-0"
            >
              <span> Includes Public Holiday? </span>
              <v-radio-group
                v-model="localLeaveType.includes_public_holiday"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="3"
              class="py-0"
            >
              <span> Includes Rest Day? </span>
              <v-radio-group
                v-model="localLeaveType.includes_rest_day"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="3"
              class="py-0"
            >
              <span> Includes Off Day? </span>
              <v-radio-group
                v-model="localLeaveType.includes_off_day"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row class="font-weight-black">
            <v-col
              cols="3"
              class="py-0"
            >
              <span> Requires document? </span>
              <v-radio-group
                v-model="localLeaveType.requires_document"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="3"
              class="py-0"
            >
              <span> To Notify HR? </span>
              <v-radio-group
                v-model="localLeaveType.notify_hr"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="3"
              class="py-0"
            >
              <span> Requires Confirmation? </span>
              <v-radio-group
                v-model="localLeaveType.requires_confirmation"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row class="font-weight-black">
            <v-col
              cols="3"
              class="py-0"
            >
              <span> Requires Reason? </span>
              <v-radio-group
                v-model="localLeaveType.requires_reason"
                row
                @change="setDefaultReasonDay"
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="localLeaveType.requires_reason"
              cols="3"
              class="py-0"
            > 
              <span> Min. Days Reason Required? </span>
              <v-text-field
                v-model="localLeaveType.minimum_days_reason_required"
                suffix="Day(s)"
                type="number"
              />
            </v-col>
          </v-row>

          <v-row class="font-weight-black">
            <v-col
              cols="3"
              class="py-0"
            >
              <span> Is Optional Leave Entitlement? </span>
              <v-radio-group
                v-model="localLeaveType.is_optional_leave_entitlement"
                row
                @change="setDefaultValue"
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="!localLeaveType.is_optional_leave_entitlement"
              cols="3"
              class="py-0"
            >
              <span> Is Lifetime? </span>
              <v-radio-group
                v-model="localLeaveType.is_lifetime"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="!localLeaveType.is_optional_leave_entitlement"
              cols="3"
              class="py-0"
            >
              <span> Requires Marital Status? </span>
              <v-radio-group
                v-model="localLeaveType.requires_marital_status"
                row
                :disabled="localLeaveType.non_editable_marital_status"
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row class="font-weight-black">
            <v-col
              v-show="localLeaveType.requires_marital_status && ![5].includes(leaveType.id)"
              cols="3"
              class="py-0"
            >
              <span> Marital Status </span>
              <v-autocomplete
                v-model="localLeaveType.marital_status_lookup_uid"
                v-validate="[5].includes(localLeaveType.id) ? '': localLeaveType.requires_marital_status ? 'required' : ''"
                :error-messages="errors.collect('marital_status_lookup_uid')"
                :items="marital_status"
                data-vv-name="marital_status_lookup_uid"     
                data-vv-as="marital status"            
                item-text="value"
                item-value="lookup_uid"
                :disabled="[4,5,7].includes(localLeaveType.id)"
              />
            </v-col>

            <v-col
              v-show="(localLeaveType.marital_status_lookup_uid && checkMaritalStatus(localLeaveType.marital_status_lookup_uid, 'Married'))||[5].includes(leaveType.id)"
              cols="3"
              class="py-0"
            >
              <div>
                <span> Gender </span>
                <v-autocomplete
                  v-model="localLeaveType.gender_lookup_uid"
                  v-validate="localLeaveType.marital_status_lookup_uid && checkMaritalStatus(localLeaveType.marital_status_lookup_uid, 'Married') ? 'required' : ''"
                  :error-messages="errors.collect('gender_lookup_uid')"
                  :items="gender"
                  data-vv-name="gender_lookup_uid"     
                  data-vv-as="gender"            
                  item-text="value"
                  :disabled="[4,5].includes(localLeaveType.id)"
                  item-value="lookup_uid"
                />
              </div>
            </v-col>

            <v-col
              v-show="(localLeaveType.marital_status_lookup_uid && checkMaritalStatus(localLeaveType.marital_status_lookup_uid, 'Married'))||[5].includes(leaveType.id)"
              cols="3"
              class="py-0"
            >
              <div>
                <span> No. Of Children Eligible </span>
                <v-text-field
                  v-model="localLeaveType.number_of_children_eligible"
                  v-validate="'required'"
                  :error-messages="errors.collect('number_of_children_eligible')"     
                  data-vv-name="number_of_children_eligible"
                  data-vv-as="number of children eligible"
                  type="number"
                />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    inject: ['$validator'],
    props: {
      leaveType: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localLeaveType: null,
      }
    },
    computed: {
      ...mapState('lookup', ['title', 'gender', 'ethnicity', 'religion', 'marital_status', 'place_of_birth']),
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localLeaveType = { ...this.leaveType }
      },
    },
    methods: { 
      checkMaritalStatus (uid, value) {
        var maritalStatusLookup = this.marital_status.filter(status => status.lookup_uid === uid)
        if (maritalStatusLookup && maritalStatusLookup.length > 0 && maritalStatusLookup[0].value === value) {
          return true
        }
        return false
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.leaveTypes().update(this.leaveType.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        let data = { 
          name: this.localLeaveType.name,
          is_continuous: this.localLeaveType.is_continuous,
          is_paid_leave: this.localLeaveType.is_paid_leave,
          requires_document: this.localLeaveType.requires_document,
          notify_hr: this.localLeaveType.notify_hr,
          requires_reason: this.localLeaveType.requires_reason,
          minimum_days_reason_required: this.localLeaveType.minimum_days_reason_required,
          is_lifetime: this.localLeaveType.is_lifetime,
          is_prorated: this.localLeaveType.is_prorated,
          is_carry_forwardable: this.localLeaveType.is_carry_forwardable,
          requires_marital_status: this.localLeaveType.requires_marital_status,
          marital_status_lookup_uid: this.localLeaveType.marital_status_lookup_uid,
          gender_lookup_uid: this.localLeaveType.gender_lookup_uid,
          number_of_children_eligible: this.localLeaveType.number_of_children_eligible,
          is_optional_leave_entitlement: this.localLeaveType.is_optional_leave_entitlement,
          requires_confirmation: this.localLeaveType.requires_confirmation,
          includes_public_holiday: this.localLeaveType.includes_public_holiday,
          includes_rest_day: this.localLeaveType.includes_rest_day,
          includes_off_day: this.localLeaveType.includes_off_day,
        }
        return data
      },

      setDefaultValue () {
        this.localLeaveType.requires_confirmation = 1
        if (this.localLeaveType.is_optional_leave_entitlement) {
          this.localLeaveType.is_lifetime = 0
          this.localLeaveType.requires_marital_status = 0
        } else {
          this.localLeaveType.is_lifetime = 0
          this.localLeaveType.requires_marital_status = 0
        }
      },

      setDefaultReasonDay () {
        if (!this.localLeaveType.requires_reason) {
          this.localLeaveType.minimum_days_reason_required = 0
        }
      },
    },
  }
</script>
